import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { invioMailManuale } from '../../../actions'
import getText from '../../shared/i18n/labels'

// COMPONENTS
import { BwmInput } from '../../shared/form/BwmInputB5'
import ErrorListAlert from '../../shared/form/ErrorListAlert'
import { Formik, Form, useFormikContext } from 'formik'
import * as Yup from 'yup'

import { PopupError } from '../../shared/popups/PopupError'
import { BtnFill } from '../../shared/BtnFill'
import * as Utility from '../../shared/Utility'

export function FacciamoNoiAdmin() {
  const auth = useSelector((state) => state.auth)
  const location = useLocation()

  const [initialValues, setInitialValues] = useState({})

  const [showErrorAlert, setShowErrorAlert] = useState(false)

  useEffect(() => {
    setInitialValues({ email: location?.state?.loginParam || '' })
  }, [])

  const validationSchema = Yup.object().shape({
    emailCliente: Yup.string().required('Campo obbligatorio')
  })

  const formErrorsMapping = [
    {
      errorKey: 'emailCliente',
      errorLabel: 'Email cliente'
    }
  ]

  const getErrors = (errors) => {
    return Utility.extractErrors(errors, formErrorsMapping)
  }

  return (
    <div className="ms-3 mt-3">
      {auth?.isAdmin && (
        <Formik
          initialValues={initialValues}
          enableReinitialize={true}
          validationSchema={validationSchema}>
          {({ errors }) => (
            <Form>
              {/* Mostra l'errore in un overlay che rimane fisso in cima solo se showErrorAlert è true */}
              {showErrorAlert &&
                errors &&
                typeof errors === 'object' &&
                Object.keys(errors).length > 0 && (
                  <div className="w-50">
                    <ErrorListAlert
                      errors={getErrors(errors)}
                      hide={() => setShowErrorAlert(false)}
                    />
                  </div>
                )}
              <FormBody setShowErrorAlert={setShowErrorAlert} />
            </Form>
          )}
        </Formik>
      )}
    </div>
  )
}

const FormBody = (props) => {
  const { values, errors, setValues, validateForm } = useFormikContext()

  const lang = useSelector((state) => state.language.language)
  const labels = getText(lang)

  const [touched, setTouched] = useState(false)

  const handleFormSubmit = async () => {
    const errors = await validateForm(values) // Validazione dei valori
    setTouched(true)
    if (Object.keys(errors).length > 0) {
      props.setShowErrorAlert(true) // Mostra l'alert degli errori
    } else {
      props.setShowErrorAlert(false) // Nascondi l'alert
      onSubmit()
    }
  }

  const onSubmit = () => {
    invioMailManuale(values).then(
      (rest) => Utility.notifySuccess(labels.SAVED_SUCCESSFULLY),
      (err) => PopupError()
    )
  }

  return (
    <>
      <div className="row mt-4">
        <div className="col-4">
          <BwmInput
            label={labels.EMAIL_CLIENT}
            className={'form-control'}
            value={values.emailCliente?.toUpperCase()}
            error={errors.emailCliente}
            touched={touched}
            onChange={(e) =>
              Utility.handleChangeValue(
                e.target.value,
                'emailCliente',
                values,
                setValues,
                true,
                true
              )
            }
          />
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-4">
          <BwmInput
            label={labels.VAT_NUMBER}
            className={'form-control'}
            value={values.codiceFiscaleCliente}
            onChange={(e) =>
              Utility.handleChangeValue(
                e.target.value,
                'codiceFiscaleCliente',
                values,
                setValues,
                true,
                true
              )
            }
          />
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-4">
          <BwmInput
            label={labels.NAME}
            className={'form-control'}
            value={values.nomeCliente}
            onChange={(e) =>
              Utility.handleChangeValue(e.target.value, 'nomeCliente', values, setValues)
            }
          />
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-4">
          <BtnFill handlerOnClick={handleFormSubmit} text={labels.SEND} />
        </div>
      </div>
    </>
  )
}
